import * as z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { type SubmitHandler, useForm } from "react-hook-form";
import type { LifeguardPreLoginFormProps } from "./LifeguardPreLoginForm.types";
import { vm } from "../../../../shared/utils/validationMessages";

const formSchema = z.object({
  citizenship_number: z
    .string()
    .trim()
    .min(1, { message: vm.CITIZENSHIP_REQUIRED })
    .regex(/^\d+$/, { message: vm.CITIZENSHIP_DIGITS_ONLY })
    .min(6, { message: vm.CITIZENSHIP_LENGTH })
    .max(10, { message: vm.CITIZENSHIP_LENGTH }),
});

type FormSchema = z.infer<typeof formSchema>;

export const useLifeguardPreLoginForm = ({
  onPreLogin,
}: Omit<LifeguardPreLoginFormProps, "isSubmitting">) => {
  const form = useForm<FormSchema>({
    resolver: zodResolver(formSchema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit: SubmitHandler<FormSchema> = (data: FormSchema) => {
    onPreLogin(data);
  };

  return { form, onSubmit };
};

